import(/* webpackMode: "eager" */ "/vercel/path0/app/[symbol]/page.tsx");
